import React from 'react'

//Components.
import ChallengeForm from '../../../components/form/challenge-form/ChallengeForm';

//Dependencies.
import { Col, Container, Row } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';

//Functions.
  //Callbacks.
  import { allVideos } from '../../../slices/allVideosSlice'
  //Slices.
  import { useSelector } from 'react-redux'

import './ChallengePage.styles.css'

const ChallengePage = () => {
   const videos = useSelector(allVideos);
   const params = useParams();

   const checkForCurrentUserVideos = Object.values(videos).filter(val => val._userID == params._userID).length

   if (checkForCurrentUserVideos) {
      return (
         <div className='challengePage'>
            <Row>
               <Col>
                  <Link to={`/member/_userID/${params._userID}/home`}>
                     <strong>BACK TO USER HOMEPAGE<span className='text-danger mx-5 px-5' style={{ fontWeight: 'bolder' }}>X</span></strong>
                  </Link>
               </Col>
            </Row>
            <Container className='challengeFormWrapper'>
               <ChallengeForm />
            </Container>
         </div>
      )
   } else {
      return (
         <div className='challengePage'>
            <Row>
               <Col>
                  <Link to={`/member/_userID/${params._userID}/home`}>
                     <strong>
                        BACK TO USER HOMEPAGE<span className='text-danger mx-5 px-5' style={{fontWeight: 'bolder'}}>X</span>
                     </strong>
                  </Link>
               </Col>
            </Row>
            <Container className='challengeFormWrapper'>
               <h1>You have <em>NO VIDEOS</em>. You need to have videos to create a challenge.</h1>
            </Container>
         </div>
      )
   }
  
}

export default ChallengePage